// extracted by mini-css-extract-plugin
module.exports = {"block":"block-294b3e","wrap":"wrap-294b3e","icon":"icon-294b3e","node":"node-294b3e","node_purple":"node_purple-294b3e","content":"content-294b3e"};